module.exports = __webpack_public_path__ + "img/propertycontrol2.cb4fb2b5.png";